/**
 * AudioWorklet processor source.
 *
 * Embedded as a string and registered via Blob URL (`addModule`) at runtime
 * so consumers don't need to host an extra file or configure their bundler.
 * This processor copies each input frame back to the main thread; the
 * resampling to 16 kHz happens there to keep the worklet thread minimal.
 */
export const WORKLET_SOURCE = `
class VoiceEnginePcmCapture extends AudioWorkletProcessor {
  process(inputs) {
    const ch = inputs[0]?.[0];
    if (ch && ch.length) {
      // Copy because the underlying buffer is reused by the host.
      this.port.postMessage(ch.slice(0));
    }
    return true;
  }
}
registerProcessor("voice-engine-pcm-capture", VoiceEnginePcmCapture);
`;
